import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DonationItem, ENVIRONMENT, Environment, Item, Lead } from '@domains';
import { Deserialize, Serialize } from 'cerialize';
import { map, Observable } from 'rxjs';

import { BaseApiService } from '../base-api.service';

@Injectable({
  providedIn: 'root',
})
export class ItemService extends BaseApiService<Item> {
  constructor(
    @Inject(ENVIRONMENT) override config: Environment,
    override http: HttpClient,
  ) {
    super(config, http, 'items', Item, 'Item');
  }

  override serialize(item: Item) {
    return {
      ...Serialize({ ...item }, Item),
    };
  }

  override deserialize(data: any): Item {
    const res = new Item({
      ...Deserialize(data, Item),
    });
    res.setInitialValue();
    return res;
  }

  search(
    query: string,
    lead: Lead,
  ): Observable<{
    query: string;
    small: boolean;
    items: DonationItem[];
    small_items: DonationItem[];
    embedding: {
      split_chance: number;
      column_name: string;
      model_name: string;
      name_weight: number;
      description_weight: number;
      min_distance: number;
    };
    small_calculation: {
      max_small_distance: number;
      mean_items_distance: number;
    };
    x_request_id: string;
  }> {
    return this.http
      .get<any>(`${this.config.urls.baseUrl}/items/search?query=${query}&activity_target_type=Lead&activity_target_id=${lead.id}`, {
        observe: 'response',
      })
      .pipe(
        map((data) => {
          return {
            ...data.body,
            items: data.body.items.map((item: any) => new DonationItem({ ...item, type: 'Item' })),
            small_items: data.body.small_items.map((item: any) => new DonationItem({ ...item, type: 'Item' })),
            x_request_id: data.headers.get('X-Request-Id') || '',
          };
        }),
      );
  }

  override create(): Observable<Item> {
    throw new Error("Endpoint doesn't exist");
  }
  override update(): Observable<Item> {
    throw new Error("Endpoint doesn't exist");
  }
  override lookup(): Observable<Item> {
    throw new Error("Endpoint doesn't exist");
  }
  override delete(): Observable<Item> {
    throw new Error("Endpoint doesn't exist");
  }
  override restore(): Observable<Item> {
    throw new Error("Endpoint doesn't exist");
  }
}
